module.exports = __webpack_public_path__ + "img/presentation-screen.ea06ce10.svg";